/* template */
<template><div class="container" v-if="(accounts.length)"><div class="title">历史12306账号</div><div v-for="(item, index) in (accounts)" :key="item.index" class="account"><div class="username">{{item.account_with_star}}<span class="tag" v-if="(item.login)">(当前登录)</span></div><div class="action"><template v-if="(item.login)"><mpx-view @tap="handleActionPrev(item, 'logout')" class="action-item">退出登录</mpx-view><mpx-view @tap="toPassenger" class="action-item" v-if="(isMini)">查看乘车人</mpx-view></template><template v-else><mpx-view @tap="loginAction(item)" class="action-item">一键登录</mpx-view><mpx-view @tap="handleActionPrev(item, 'delete')" class="action-item">删除</mpx-view></template></div></div><es-dialog showCancelButton showConfirmButton title="温馨提示" :show="(show)" algin="center" @cancel="onCancel" @confirm="onConfirm"><div slot="content">{{ dialogMsg }}</div></es-dialog></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c009f1e"}'>
.container
  border-radius 8px
  box-sizing border-box
  border 1px solid #EEEEEE
  padding 12px 12px 16px
  .title
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    line-height 14px
    letter-spacing 0px
    color #999999
  .username
    overflow hidden
    white-space nowrap
    text-overflow ellipsis
    .tag
      white-space nowrap
  .account
    margin-top 16px
    font-family PingFangSC-Regular
    font-weight 400
    font-size 12px
    height 14px
    line-height 1
    box-sizing border-box
    color #000
    display flex
    align-items center
    justify-content space-between
    .action
      flex none
      color #666
      display flex
      align-items center
      &-item
        padding 8px
        position relative
        &:last-child
          padding-right 0
        &+.action-item
          &::before
            position absolute
            left 0
            top 10px
            content ''
            height 8px
            width 1px
            background-color #c2c2c2
   
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4c009f1e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./history-account.mpx.js?isComponent&outputPath=components%2Fhistory-account4c009f1e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./history-account.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fhistory-account4c009f1e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4c009f1e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/history-account4c009f1e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
